import { API_UPDATE_PROFESSIONAL_DATA } from "@/common/consts/apiUrls";
import { httpClient } from "@/config";

export const updateProfessionalDataService = (formData: FormData) =>
  httpClient.put(API_UPDATE_PROFESSIONAL_DATA, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
